//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Chip from '@components/atoms/chip/Chip';
import { BodyText } from '@components/atoms/text/Text';

interface CatalogIdentifierDisplayProps {
  identifiers: string[];
  title: string;
}

export const CatalogIdentifierDisplay = ({
  identifiers,
  title,
}: CatalogIdentifierDisplayProps) => {
  if (identifiers.length === 0) {
    return null;
  }

  return (
    <UpcContainer>
      <BodyText>{title}</BodyText>
      <ChipsContainer>
        {identifiers.map((identifier) => (
          <Chip
            key={identifier}
            chipType='default'
            isDisabled
            size='small'
            text={identifier}
          />
        ))}
      </ChipsContainer>
    </UpcContainer>
  );
};

const UpcContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacings[2]};
`;

const ChipsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacings[2]};
`;
